import { tns } from 'tiny-slider/dist/tiny-slider'

const carSlider = (prefix) => {
  if(document.querySelectorAll(prefix + '-slider .item').length > 1) {
    let slider = tns({
      container: prefix + '-slider',
      items: 1,
      slideBy: 'page',
      mouseDrag: 'mouseDrag',
      lazyload: true,
      autoplay: false,
      prevButton: prefix + '-arrow-left',
      nextButton: prefix + '-arrow-right',
      useLocalStorage: false,
    });
  }
};
export default carSlider
